import React, { useCallback, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _size from 'lodash/size';
import { addMultipleSelectAnswer, removeMultipleSelectAnswer } from 'redux/actions/consultation/answer';
import { consultationSelector } from 'redux/selectors/consultation';
import { ColumnDiv } from 'styles/elements/div';
import { AdditionalInfo } from 'styles/elements/infoBoxes/info';
import SelectOption from 'styles/blocks/selectOption';
import Question from 'styles/blocks/question';
import { Select } from './select';
import { NextButton } from '../nextButton';

/*
* Question guidance appears withing the answer means refactor is needed. isGuidanceTextShownAboveQuestion shouldn't need to be here either.
* */

export function MultipleSelect({ question, isMounted, onClickNextQuestion, isGuidanceTextShownAboveQuestion }) {
  const mapState = useCallback(state => consultationSelector(state), []);
  const {
    isAllMultipleInvalid,
    multiSelectedAnswers,
    isClinicalReviewMode,
    product,
  } = useMappedState(mapState);
  function createMarkup(text) {
    return { __html: text };
  }

  const dispatch = useDispatch();

  const [selectedAnswers, setSelectedAnswers] = useState(multiSelectedAnswers);
  const [isOptional] = useState(question.optional);
  const [answersListSize] = useState(() => _size(question.answers));

  const addValue = useCallback(answerId => {
    setSelectedAnswers([...selectedAnswers, { answerId: answerId }]);
    dispatch(addMultipleSelectAnswer({ answerId: answerId }), []);
  }, [dispatch, selectedAnswers]);

  const removeValue = useCallback(answerId => {
    setSelectedAnswers(_filter(selectedAnswers, item => item.answerId !== answerId));
    dispatch(removeMultipleSelectAnswer({ answerId: answerId }), []);
  }, [dispatch, selectedAnswers]);

  const isNextButtonDisabled = !isOptional && (_isEmpty(selectedAnswers) || isAllMultipleInvalid);

  return (
    <ColumnDiv>
      <SelectOption.GroupWrapper role="group" aria-label="Answer options" answersListSize={answersListSize}>
        {_map(question.answers, (answer, index) => (
          <SelectOption.FieldWrapper key={`multiSelect-${index}`} answersListSize={answersListSize}>
            <Select
              answerId={answer.answerId}
              text={answer.text}
              triageLevel={answer.triageLevel}
              isMounted={isMounted}
              index={index}
              selected={!!_find(selectedAnswers, selectedAnswer => selectedAnswer.answerId === answer.answerId)}
              onSelectOption={addValue}
              onDeselectOption={removeValue}
              isClinicalReviewMode={isClinicalReviewMode}
              product={product}
            />
            <AdditionalInfo infoGroup={[answer.guidanceScript]} />
          </SelectOption.FieldWrapper>
        ))}
      </SelectOption.GroupWrapper>
      {question.guidanceScript && !isGuidanceTextShownAboveQuestion && <Question.ETriageHelpLabel dangerouslySetInnerHTML={createMarkup(question.guidanceScript)} />}
      <NextButton dataAutomation={`nextButton-${question.questionId}`} onClick={onClickNextQuestion} isDisabled={isNextButtonDisabled} />
    </ColumnDiv>
  );
}
